/* RL UVOLA — landing page.rl-uvola (clon de tryuvola.com/pages/liver-detox). 15-oct-2026
   Cuenta atrás de la barra, cabecera bloqueada, anillos de estadísticas, galería, paquetes y compra
   (como el original: «Agregar al carrito» → /cart/add.js y DIRECTO a /checkout; las variantes están en
   regalos.config.directo y el ml-cart-drawer añade los regalos), mini reseñas, «Leer más reseñas» y pie. */
(function(){
  if (window.__rlu) return; window.__rlu = 1;
  function q(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function pad(n){ return (n < 10 ? '0' : '') + n; }

  /* cabecera bloqueada también ante clics programáticos (igual que en las fichas) */
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest('#Details-menu-drawer-container > summary, .header__icon--menu, [data-rl-menu], a.header-logo') : null;
    if (t && document.querySelector('.rlu')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('toggle', function(e){
    var d = e.target;
    if (d && d.id === 'Details-menu-drawer-container' && d.open && document.querySelector('.rlu')) { d.open = false; d.removeAttribute('open'); document.documentElement.style.removeProperty('overflow'); document.body.style.removeProperty('overflow'); }
  }, true);

  function cuenta(){
    var els = q('[data-rlu-cd]'); if (!els.length) return;
    function tick(){
      var now = new Date(), fin = new Date(now); fin.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((fin - now) / 1000)), h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), ss = s % 60;
      els.forEach(function(el){ var a = el.querySelector('[data-h]'), b = el.querySelector('[data-m]'), c = el.querySelector('[data-s]'); if (a) a.textContent = pad(h); if (b) b.textContent = pad(m); if (c) c.textContent = pad(ss); });
    }
    tick(); setInterval(tick, 1000);
  }

  function anillos(){
    var rs = q('.rlu-ring[data-pct]'); if (!rs.length) return;
    function go(r){ var fg = r.querySelector('.fg'); if (fg) fg.style.strokeDashoffset = (251.33 * (1 - (+r.dataset.pct || 0) / 100)).toFixed(2); }
    if (!('IntersectionObserver' in window)) { rs.forEach(go); return; }
    var io = new IntersectionObserver(function(en){ en.forEach(function(x){ if (x.isIntersecting) { go(x.target); io.unobserve(x.target); } }); }, { threshold: .3 });
    rs.forEach(function(r){ io.observe(r); });
  }

  function galeria(){
    q('.rlu-gal').forEach(function(g){
      var tr = g.querySelector('.rlu-gal__track'), sl = q('.rlu-gal__sl', g), th = q('.rlu-gal__thumbs button', g), bar = g.querySelector('.rlu-gal__barra span');
      var izq = g.querySelector('.rlu-gal__flecha--izq'), der = g.querySelector('.rlu-gal__flecha--der');
      if (!tr || !sl.length) return;
      if (bar) bar.style.width = (100 / sl.length) + '%';
      function idx(){ var w = sl[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(tr).columnGap) || 0); return Math.round(tr.scrollLeft / (w || 1)); }
      function upd(){ var i = Math.min(sl.length - 1, Math.max(0, idx()));
        th.forEach(function(b, j){ b.classList.toggle('on', i === j); });
        if (bar) bar.style.transform = 'translateX(' + (i * 100) + '%)';
        if (izq) izq.style.opacity = i === 0 ? '.45' : '1'; if (der) der.style.opacity = i === sl.length - 1 ? '.45' : '1'; }
      function ir(i){ i = Math.min(sl.length - 1, Math.max(0, i)); tr.scrollTo({ left: sl[i].offsetLeft - sl[0].offsetLeft, behavior: 'smooth' }); }
      tr.addEventListener('scroll', function(){ window.requestAnimationFrame(upd); }, { passive: true });
      th.forEach(function(b, j){ b.addEventListener('click', function(){ ir(j); }); });
      if (izq) izq.addEventListener('click', function(){ ir(idx() - 1); });
      if (der) der.addEventListener('click', function(){ ir(idx() + 1); });
      upd();
    });
  }

  function money(c){ var v = (c / 100).toFixed(2).split('.'); return '$' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (v[1] === '00' ? '' : '.' + v[1]); }

  function compra(){
    q('.rlu-compra').forEach(function(root){
      var pks = q('.rlu-pk', root), sel = null;
      function pick(b){ sel = b; pks.forEach(function(x){ var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); }); }
      pks.forEach(function(b){ b.addEventListener('click', function(){ pick(b); }); });
      pick(pks.filter(function(b){ return b.classList.contains('on'); })[0] || pks[0]);
      q('[data-rlu-comprar]', root).forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault(); if (!sel || btn.getAttribute('aria-busy') === 'true') return;
          var v = +sel.dataset.variant; btn.setAttribute('aria-busy', 'true');
          var irPago = function(){ location.href = '/checkout'; };
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v, quantity: 1 }] }) })
            .then(function(r){ if (!r.ok) throw r; setTimeout(irPago, 3000); })
            .catch(function(){ btn.removeAttribute('aria-busy'); location.href = '/cart/' + v + ':1'; });
        });
      });
    });
  }

  function mini(){
    q('.rlu-mini').forEach(function(m){
      var s = q('.rlu-mini__sl', m), i = 0; if (s.length < 2) return;
      function go(n){ i = (n + s.length) % s.length; s.forEach(function(x, j){ x.classList.toggle('on', i === j); }); }
      var p = m.querySelector('[data-rlu-mini-prev]'), n = m.querySelector('[data-rlu-mini-next]');
      if (p) p.addEventListener('click', function(){ go(i - 1); }); if (n) n.addEventListener('click', function(){ go(i + 1); });
    });
  }

  function resenas(){
    q('[data-rlu-mas]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); var sec = b.closest('.rlu-resenas'); q('.rlu-oculta', sec).forEach(function(c){ c.classList.remove('rlu-oculta'); }); b.style.display = 'none'; });
    });
  }

  function pie(){
    var esc = window.matchMedia('(min-width: 990px)').matches;
    q('.rlu-pie__col').forEach(function(d){ if (esc) d.setAttribute('open', ''); else d.removeAttribute('open'); });
  }

  function init(){ cuenta(); anillos(); galeria(); compra(); mini(); resenas(); pie(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
